import { defineComponent as _defineComponent } from 'vue'
import { withDefaults } from "vue"

// Props
interface Props {
	classes: string[]
	height?: number
	width?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentConditionPill',
  props: {
    classes: { default: () => [" bg-primary-blue", "text-white"] },
    height: { default: 20 },
    width: { default: 55 }
  },
  setup(__props: any) {

const props = __props as { classes: string[], height: number, width: number };



return { __sfc: true,props }
}

})